'use strict';

var base = require('./base');

function isProductPurchasable(product) {
    return (product.readyToOrder || product.productType === 'bundle') && product.available;
}

/**
 * Enable/disable UI elements
 * @param {boolean} enableOrDisable - true or false
 */
function updateAddToCartEnableDisableOtherElements(enableOrDisable) {
    $('button.add-to-cart-global').attr('disabled', enableOrDisable);
}

function getQuantityVariationSavingsEndpoint(params) {
    var endpointUrl = $('.js-quantityVariationSavingsUrl').first().val();
    if (!endpointUrl || !params || !params.pid) {
        return null;
    }

    return endpointUrl + (endpointUrl.indexOf('?') === -1 ? '?' : '&') + $.param(params);
}

function getButtonVariationValue($button) {
    if (!$button || !$button.length) {
        return null;
    }

    var value = $button.attr('data-attr-value');
    if (value !== undefined && value !== null && value !== '') {
        return String(value);
    }

    var nestedValue = $button.find('[data-attr-value]').first().attr('data-attr-value');
    if (nestedValue === undefined || nestedValue === null || nestedValue === '') {
        return null;
    }

    return String(nestedValue);
}

function getButtonAttributeId($button) {
    if (!$button || !$button.length) {
        return null;
    }

    var attributeId = $button.closest('[data-attr]').attr('data-attr');
    return attributeId || null;
}

function getButtonVariationOptionId($button) {
    if (!$button || !$button.length) {
        return null;
    }

    var optionId = $button.attr('data-attr-option-id');
    if (optionId === undefined || optionId === null || optionId === '') {
        return null;
    }

    return String(optionId);
}

function resetQuantityVariationSavingsBadge($scope) {
    if (!$scope || !$scope.length) {
        $scope = $('.js-productDetail');
    }

    $scope.find('.js-quantityVariationSavingsBadge').addClass('d-none').empty();
}

function invalidateVariationCardSavings($productContainer) {
    var refreshToken = {};
    $productContainer.find('.js-quantityVariationCard').data('variationCardRefreshToken', refreshToken);
    $productContainer.find('.js-quantityVariationCard [data-card-field="discount"], .js-quantityVariationCard [data-card-field="listPrice"]')
        .addClass('d-none').empty();
}

function setQuantityVariationCardsLoading($buttons, isLoading) {
    $buttons.attr('aria-busy', isLoading ? 'true' : 'false');
    $buttons.find('.js-quantityVariationCardLoader').toggleClass('d-none', !isLoading);
}

function renderQuantityVariationCards($buttons, data) {
    var $cards = $buttons.filter('.js-quantityVariationCard');
    setQuantityVariationCardsLoading($cards, false);
    $cards.toggleClass('d-none', !!(data && data.success && data.variantExists === false));
    var card = data && data.success ? {
        label: data.card && data.card.label,
        content: data.card && data.card.content,
        hideVariationLabel: !!(data.card && data.card.hideVariationLabel),
        unitPrice: data.card && data.card.unitPrice,
        price: data.applicable ? data.variationPrice : '',
        listPrice: data.applicable ? data.strikedPrice : ''
    } : {};
    var hasPrice = typeof card.price === 'string' && !!card.price;
    var savingsText = '';
    if (hasPrice && data.shouldDisplay && typeof data.badgeText === 'string') {
        savingsText = data.badgeText;
    }
    var fields = ['price', 'unitPrice', 'listPrice', 'discount'];

    $cards.each(function () {
        var $card = $(this);
        var packLabel = typeof card.content === 'string' ? card.content : '';
        fields.forEach(function (field) {
            var value = typeof card[field] === 'string' ? card[field] : '';
            if ((field === 'listPrice' || field === 'discount') && !hasPrice) {
                value = '';
            }
            if (field === 'discount') {
                value = savingsText;
            }
            $card.find('[data-card-field="' + field + '"]').text(value).toggleClass('d-none', !value);
        });
        $card.find('[data-card-field="content"]').empty().addClass('d-none');
        var label = typeof card.label === 'string' && card.label ? card.label : $card.attr('data-card-label');
        if (card.hideVariationLabel && packLabel) {
            label = packLabel;
        } else if (packLabel && label) {
            label = packLabel + ' - ' + label;
        }
        $card.find('.cc-pdp__product__attribute__button__text').text(label).removeClass('cc-pdp__product__attribute__cardHeaderText--hidden');
        $card.toggleClass('cc-pdp__product__attribute__button--priced', hasPrice);
    });
}

function renderQuantityVariationSavingsBadgeForButtons(data, $buttons) {
    if (!$buttons || !$buttons.length) {
        return;
    }

    renderQuantityVariationCards($buttons, data);

    var $badges = $buttons.find('.js-quantityVariationSavingsBadge');

    if (!data || !data.success || !data.applicable) {
        if (data && data.hide) {
            var $button = $badges.closest('.js-variantsButton');
            $button.addClass('cc-pdp__product__variants__disabled');
        }
        $badges.addClass('d-none').empty();
        return;
    }

    if (data.shouldDisplay && data.badgeText && data.savingsPercentage !== 100) {
        $badges.text(data.badgeText).removeClass('d-none');
    } else {
        $badges.addClass('d-none').empty();
    }
}

function refreshQuantityVariationSavingsForAllButtons($productContainer) {
    if (!$productContainer || !$productContainer.length) {
        return;
    }

    resetQuantityVariationSavingsBadge($productContainer);
    invalidateVariationCardSavings($productContainer);

    var currentPid = $productContainer.data('pid');
    if (!currentPid) {
        return;
    }

    var $regularDelivery = $productContainer.find('.js-regularDelivery').first();
    var selectedDelivery = $regularDelivery.find('.js-purchaseType:checked').data('value-id');
    var defaultDelivery = $regularDelivery.data('default-value-id');
    var showRDPrice = !!(selectedDelivery && defaultDelivery && String(selectedDelivery) !== String(defaultDelivery));
    var buttonsByValue = {};
    $productContainer.find('.js-quantityVariationCard').each(function () {
        var $button = $(this);
        var attributeId = getButtonAttributeId($button);
        var attributeValue = getButtonVariationValue($button);
        var attributeOptionId = getButtonVariationOptionId($button);

        if (!attributeId || !attributeValue) {
            return;
        }

        var key = attributeId + '::' + (attributeOptionId || attributeValue);
        if (!buttonsByValue[key]) {
            buttonsByValue[key] = {
                params: {
                    pid: currentPid,
                    attributeId: attributeId,
                    attributeValue: attributeValue,
                    attributeOptionId: attributeOptionId,
                    showRDPrice: showRDPrice
                },
                buttons: $()
            };
        }

        buttonsByValue[key].buttons = buttonsByValue[key].buttons.add($button);
    });

    Object.keys(buttonsByValue).forEach(function (key) {
        var refreshToken = buttonsByValue[key].buttons.first().data('variationCardRefreshToken');
        var endpoint = getQuantityVariationSavingsEndpoint(buttonsByValue[key].params);
        if (!endpoint) {
            renderQuantityVariationSavingsBadgeForButtons(null, buttonsByValue[key].buttons);
            return;
        }

        setQuantityVariationCardsLoading(buttonsByValue[key].buttons, true);
        $.ajax({
            url: endpoint,
            method: 'GET',
            success: function (data) {
                if (buttonsByValue[key].buttons.first().data('variationCardRefreshToken') !== refreshToken) {
                    return;
                }
                renderQuantityVariationSavingsBadgeForButtons(data, buttonsByValue[key].buttons);
            },
            error: function () {
                if (buttonsByValue[key].buttons.first().data('variationCardRefreshToken') !== refreshToken) {
                    return;
                }
                renderQuantityVariationSavingsBadgeForButtons(null, buttonsByValue[key].buttons);
            }
        });
    });
}

module.exports = {
    methods: {
        updateAddToCartEnableDisableOtherElements: updateAddToCartEnableDisableOtherElements,
    },

    selectAttribute: base.selectAttribute,

    quantity: base.quantity,

    addToCart: base.addToCart,

    updateAttributesAndDetails: function () {
        $('body').on('product:statusUpdate', function (e, data) {
            var $productContainer = $('.js-productDetail[data-pid="' + data.id + '"]');

            $productContainer.find('.description-and-detail .product-attributes').empty().html(data.attributesHtml);

            if (data.shortDescription) {
                $productContainer.find('.description-and-detail .description').removeClass('hidden-xl-down');
                $productContainer.find('.description-and-detail .description .content').empty().html(data.shortDescription);
            } else {
                $productContainer.find('.description-and-detail .description').addClass('hidden-xl-down');
            }

            if (data.longDescription) {
                $productContainer.find('.description-and-detail .details').removeClass('hidden-xl-down');
                $productContainer.find('.description-and-detail .details .content').empty().html(data.longDescription);
            } else {
                $productContainer.find('.description-and-detail .details').addClass('hidden-xl-down');
            }
        });
    },

    showSpinner: function () {
        $('body').on('product:beforeAddToCart', function () {
            $.spinner().start();
        });
    },
    updateAttribute: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if ($('.js-productDetail>.bundle-items').length) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else if ($('.product-set-detail').eq(0)) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else {
                $('.product-id').text(response.data.product.id);
                $('.js-productDetail:not(".bundle-item")').data('pid', response.data.product.id);
            }
        });
    },
    updateQuantityVariationSavings: function () {
        var $defaultContainer = $('.js-productDetail').first();
        if ($defaultContainer.length) {
            refreshQuantityVariationSavingsForAllButtons($defaultContainer);
        }

        $('body').on('product:beforeAttributeSelect', function (e, response) {
            if (response && response.container) {
                invalidateVariationCardSavings(response.container);
            }
        });

        $('body').on('product:afterAttributeSelect', function (e, response) {
            if (!response || !response.container || !response.data || !response.data.product || !response.data.product.id) {
                return;
            }

            refreshQuantityVariationSavingsForAllButtons(response.container);
        });
    },
    updateAddToCart: function () {
        $('body').on('product:updateAddToCart', function (e, response) {
            // update local add to cart (for sets)
            var isProductAvailable = isProductPurchasable(response.product);
            $('.js-addToCart', response.$productContainer).toggle(isProductAvailable);
            $('.js-addToCartSticky', response.$productContainer).toggle(isProductAvailable);

            var enable = isProductAvailable;
            module.exports.methods.updateAddToCartEnableDisableOtherElements(!enable);
        });
    },
    updateAvailability: function () {
        $('body').on('product:updateAvailability', function (e, response) {
            $('div.availability', response.$productContainer).data('ready-to-order', response.product.readyToOrder).data('available', response.product.available);

            $('.availability-msg', response.$productContainer).empty().html(response.message);

            if ($('.global-availability').length) {
                var allAvailable = $('.js-productAvailability')
                    .toArray()
                    .every(function (item) {
                        return $(item).data('available');
                    });

                var allReady = $('.js-productAvailability')
                    .toArray()
                    .every(function (item) {
                        return $(item).data('ready-to-order');
                    });

                $('.global-availability').data('ready-to-order', allReady).data('available', allAvailable);

                $('.global-availability .availability-msg')
                    .empty()
                    .html(allReady ? response.message : response.resources.info_selectforstock);
            }
        });
    },
    focusChooseBonusProductModal: base.focusChooseBonusProductModal(),

    addToCartFromComparison: function () {
        $(document).on('click', 'button.js-addToCartComparison, button.js-addToCartFromCompare', function () {
            var addToCartUrl;
            var pid;

            $('body').trigger('product:beforeAddToCart', this);

            pid = $(this).closest('[data-pid]').attr('data-pid') || $(this).data('pid');

            var $productContainer = $(this).closest('[data-pid]');

            addToCartUrl = $('.comparison-add-to-cart-url').val();

            var form = {
                pid: pid,
                quantity: 1,
            };

            $(this).trigger('updateAddToCartFormData', form);
            if (addToCartUrl) {
                $.ajax({
                    url: addToCartUrl,
                    method: 'POST',
                    data: form,
                    success: (data) => {
                        if (!data.error) {
                            $('body').trigger('product:afterAddToCart', data);
                            $('.minicart .minicart-quantity').html(data.quantityTotal);

                            $productContainer.find('.js-addToCartComparison, .js-addToCartFromCompare').addClass('d-none');
                            $.spinner().stop();
                        } else {
                            $.spinner().stop();
                        }
                    },
                    error: function () {
                        $.spinner().stop();
                    },
                });
            }
        });
    },

    /**
     * Update key points and free gift sections based on product variant
     */
    updateKeyPoints: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if (!response?.data?.product) return;

            var product = response.data.product;
            var $productContainer = response.container || $('.js-productDetail');

            var hasKeyPoints = product.custom?.keyPoints?.elements?.length > 0;
            var hasFreeGift = product.freeGift && !$.isEmptyObject(product.freeGift);

            // Update highlighted attributes content with new product data
            if (hasKeyPoints) {
                var highlightedAttributesHtml = '';
                var keyPoints = product.custom.keyPoints.elements;
                var maxDisplay = Math.min(2, keyPoints.length);

                for (var i = 0; i < maxDisplay; i++) {
                    var attr = keyPoints[i];
                    highlightedAttributesHtml +=
                        '<div class="cc-pdp__highlightedAttribute">' +
                        '<span class="cc-pdp__highlightedAttribute__label">' + attr.text + '</span>' +
                        '<picture>' +
                        '<img src="' + attr.icon + '" class="cc-pdp__highlightedAttribute__img" alt="" />' +
                        '</picture>' +
                        '</div>';
                }

                $('.cc-pdp__highlightedAttributes.js-mobileHighlightedAttributes').html(highlightedAttributesHtml);
                $('.cc-pdp__highlightedAttributes.js-desktopHighlightedAttributes').html(highlightedAttributesHtml);
            }

            // Toggle visibility between freeGift offers and highlightedAttributes
            if (hasFreeGift) {
                var giftImage = product.freeGift.giftImage;
                if (giftImage?.absURL) {
                    var $offerImage = $('.cc-pdp__offers__image');
                    $offerImage.attr('src', giftImage.absURL);
                    $offerImage.attr('alt', giftImage.alt || product.productName);
                }

                // Show offers (mobile and desktop), hide highlighted attributes
                $('.cc-pdp__offers.js-mobileOffers')
                    .removeClass('d-none')
                    .addClass('d-lg-none d-flex');
                $('.cc-pdp__offers.js-desktopOffers')
                    .removeClass('d-none')
                    .addClass('d-none d-lg-flex');
                $('.cc-pdp__highlightedAttributes.js-mobileHighlightedAttributes')
                    .addClass('d-none')
                    .removeClass('d-lg-none d-flex');
                $('.cc-pdp__highlightedAttributes.js-desktopHighlightedAttributes')
                    .addClass('d-none')
                    .removeClass('d-lg-flex');
            } else if (hasKeyPoints) {
                // Hide offers, show highlighted attributes (mobile and desktop)
                $('.cc-pdp__offers.js-mobileOffers')
                    .addClass('d-none')
                    .removeClass('d-lg-none d-flex');
                $('.cc-pdp__offers.js-desktopOffers')
                    .addClass('d-none')
                    .removeClass('d-lg-flex');
                $('.cc-pdp__highlightedAttributes.js-mobileHighlightedAttributes')
                    .removeClass('d-none')
                    .addClass('d-lg-none d-flex');
                $('.cc-pdp__highlightedAttributes.js-desktopHighlightedAttributes')
                    .removeClass('d-none')
                    .addClass('d-none d-lg-flex');
            } else {
                // Hide both if neither exists
                $('.cc-pdp__offers.js-mobileOffers')
                    .addClass('d-none')
                    .removeClass('d-lg-none d-flex');
                $('.cc-pdp__offers.js-desktopOffers')
                    .addClass('d-none')
                    .removeClass('d-lg-flex');
                $('.cc-pdp__highlightedAttributes.js-mobileHighlightedAttributes')
                    .addClass('d-none')
                    .removeClass('d-lg-none d-flex');
                $('.cc-pdp__highlightedAttributes.js-desktopHighlightedAttributes')
                    .addClass('d-none')
                    .removeClass('d-lg-flex');
            }

            // Update key points accordion content
            var $keyPointsAccordion = $('#descriptionAccordion #keyPointsHeading').closest('.cc-accordion__item');
            var $keyPointsBody = $('#keyPointsCollapse .cc-accordion__body');

            if (hasKeyPoints && $keyPointsBody.length) {
                var keyPointsData = product.custom.keyPoints;
                var keyPointsHtml = keyPointsData.description
                    ? '<p class="cc-text-lg">' + keyPointsData.description + '</p>'
                    : '';

                if (keyPointsData.elements.length) {
                    keyPointsHtml += '<div class="cc-pdp__description__list">';
                    keyPointsData.elements.forEach(function (keyPoint) {
                        keyPointsHtml +=
                            '<div class="cc-pdp__description__list__item">' +
                            '<picture>' +
                            '<img class="cc-pdp__description__list__item__icon" src="' + keyPoint.icon + '" alt="" />' +
                            '</picture>' +
                            '<div class="cc-pdp__description__list__item__text">' +
                        '<p class="cc-text-md text-center">' + keyPoint.text + '</p>' +
                            '</div>' +
                            '</div>';
                    });
                    keyPointsHtml += '</div>';
                }

                $keyPointsBody.html(keyPointsHtml);
                $keyPointsAccordion.show();
            } else {
                $keyPointsAccordion.hide();
            }
        });
    },

    /**
     * Update drinks/beverages section for compatible products
     */
    updateDrinks: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if (!response?.data?.product) return;

            var product = response.data.product;
            var hasDrinks = product.custom?.classicBeverageAvailableList?.length > 0;

            var $drinksAccordion = $('#descriptionAccordion #drinksHeading').closest('.cc-accordion__item');
            var $drinksBody = $('#drinksCollapse .cc-accordion__body');

            if (hasDrinks && $drinksBody.length) {
                var beverageDesc = product.custom.foodAndBeverageAttributes?.classicBeverageAvailableDescription;
                var drinksHtml = beverageDesc ? '<p class="cc-text-lg">' + beverageDesc + '</p>' : '';

                drinksHtml += '<div class="cc-pdp__description__list">';
                product.custom.classicBeverageAvailableList.forEach(function (drink) {
                    drinksHtml += '<div class="cc-pdp__description__list__item">';
                    if (drink.icon) {
                        drinksHtml +=
                            '<picture>' +
                            '<img class="cc-pdp__description__list__item__icon" src="' + drink.icon + '" alt="" />' +
                            '</picture>';
                    }
                    drinksHtml +=
                        '<div class="cc-pdp__description__list__item__text">' +
                    '<p class="cc-text-md text-center">' + drink.value + '</p>' +
                        '</div>' +
                        '</div>';
                });
                drinksHtml += '</div>';

                $drinksBody.html(drinksHtml);
                $drinksAccordion.show();
            } else {
                $drinksAccordion.hide();
            }
        });
    },

    /**
     * Update aromatic profile section for coffee products
     */
    updateAromaticProfile: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if (!response?.data?.product) return;

            var product = response.data.product;
            var hasAromaticProfile = product.custom?.coffeeAttributes?.roastBeanColour;

            var $aromaticProfileAccordion = $('#descriptionAccordion #aromaticProfileHeading').closest('.cc-accordion__item');
            var $aromaticProfileBody = $('#aromaticProfileCollapse .cc-accordion__body');

            if (hasAromaticProfile && $aromaticProfileBody.length) {
                var resources = response.data?.resources || {};
                var coffeeAttrs = product.custom.coffeeAttributes;
                var roastDesc = coffeeAttrs.roastBeanColourDescription || coffeeAttrs.roastBeanColour.label;

                var aromaticHtml = '<div class="cc-pdp__aromaticProfile__wrapper">' +
                    '<div class="cc-pdp__aromaticProfile__section">' +
                    '<div class="cc-pdp__aromaticProfile__section__content">' +
                    '<h3 class="cc-heading-sm">' + resources.torrificationLabel + ' - ' + roastDesc + '</h3>';

                // Torrefaction Scale
                aromaticHtml += '<div class="cc-pdp__aromaticProfile__torrefactionScale">';
                for (var i = 1; i <= 10; i++) {
                    var selectedClass = coffeeAttrs.roastBeanColour.level == i
                        ? 'cc-pdp__aromaticProfile__torrefactionScale__level__selected'
                        : '';
                    aromaticHtml +=
                        '<div class="cc-pdp__aromaticProfile__torrefactionScale__level cc-pdp__aromaticProfile__torrefactionScale__level--' + i + ' ' + selectedClass + '">' +
                        '<span class="cc-text-md">' + i + '</span>' +
                        '</div>';
                }
                aromaticHtml += '</div>';

                aromaticHtml +=
                    '<div class="cc-pdp__aromaticProfile__divider">' +
                    '<div class="cc-pdp__aromaticProfile__divider__line"></div>' +
                    '</div>' +
                    '<div class="cc-pdp__aromaticProfile__torrefaction__notes">' +
                    '<div class="cc-pdp__aromaticProfile__torrefaction__note">' +
                    '<p class="cc-pdp__aromaticProfile__torrefaction__noteTitle cc-text-md">' + resources.acidityLabel + '</p>' +
                    '<p class="cc-pdp__aromaticProfile__torrefaction__noteText cc-text-md">' + resources.aromaticFlavorsLabel + '</p>' +
                    '</div>' +
                    '<div class="cc-pdp__aromaticProfile__torrefaction__note">' +
                    '<p class="cc-pdp__aromaticProfile__torrefaction__noteTitle cc-text-md">' + resources.bitternessLabel + '</p>' +
                    '<p class="cc-pdp__aromaticProfile__torrefaction__noteText cc-text-md">' + resources.aromaticRoastingLabel + '</p>' +
                    '</div>' +
                    '</div>' +
                    '</div>'; // End notes + section__content

                // Torrefaction modal section content asset (inside section, after section__content)
                aromaticHtml += (coffeeAttrs.torrefactionModalHtml || '');
                aromaticHtml += '</div>'; // End first section

                // Aromatic Family Section
                if (coffeeAttrs.dominantNote) {
                    var dominantNote = coffeeAttrs.dominantNote;
                    var secondaryNote = coffeeAttrs.secondaryNote;

                    aromaticHtml +=
                        '<div class="cc-pdp__aromaticProfile__section">' +
                    '<div class="cc-pdp__aromaticProfile__section__content">' +
                        '<h3 class="cc-heading-sm">' + resources.aromaticFamilyLabel + ' - ' + dominantNote.label + '</h3>' +
                        '<div class="cc-pdp__aromaticProfile__families">' +
                        '<div class="cc-pdp__aromaticProfile__family">' +
                        (dominantNote.icon ? '<picture><img class="cc-pdp__aromaticProfile__family__icon" src="' + dominantNote.icon + '" alt="' + dominantNote.label + '" /></picture>' : '') +
                        '<div class="cc-pdp__aromaticProfile__family__label">' +
                        '<p class="cc-text-md">' + resources.mainFamilyLabel + '</p>' +
                        '<p class="cc-text-lg font-weight-bold">' + dominantNote.label + '</p>' +
                        '</div>' +
                        '</div>';

                    if (secondaryNote) {
                        aromaticHtml +=
                            '<div class="cc-pdp__aromaticProfile__family">' +
                            (secondaryNote.icon ? '<picture><img class="cc-pdp__aromaticProfile__family__icon" src="' + secondaryNote.icon + '" alt="' + secondaryNote.label + '" /></picture>' : '') +
                            '<div class="cc-pdp__aromaticProfile__family__label">' +
                            '<p class="cc-text-md">' + resources.secondaryFamilyLabel + '</p>' +
                            '<p class="cc-text-lg font-weight-bold">' + secondaryNote.label + '</p>' +
                            '</div>' +
                            '</div>';
                    }

                    aromaticHtml += '</div>'; // End families

                    // Tasting Notes
                    if (coffeeAttrs.coffeeTastingNotes?.length) {
                        aromaticHtml +=
                            '<div class="cc-pdp__aromaticProfile__notes">' +
                            '<p class="cc-text-md font-weight-bold">' + resources.tastingNotesLabel + '</p>' +
                            '<ul class="cc-pdp__aromaticProfile__notesList">';

                        coffeeAttrs.coffeeTastingNotes.forEach(function (note) {
                            aromaticHtml += '<li class="cc-pdp__aromaticProfile__note cc-text-md">' + note + '</li>';
                        });

                        aromaticHtml += '</ul></div>';
                    }

                    aromaticHtml += '</div>'; // End section__content
                    aromaticHtml += (coffeeAttrs.aromaticFamilyModalHtml || '');
                    aromaticHtml += '</div>'; // End section
                }

                aromaticHtml += '</div>'; // End wrapper

                $aromaticProfileBody.html(aromaticHtml);
                $aromaticProfileAccordion.show();
            } else {
                $aromaticProfileAccordion.hide();
            }
        });
    },

    /**
     * Update coffee selection/range information
     */
    updateCoffeeSelection: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if (!response?.data?.product) return;

            var product = response.data.product;
            var hasCoffeeRange = product.custom?.coffeeAttributes?.coffeeRange?.id;

            var $coffeeSelectionAccordion = $('#descriptionAccordion #coffeeSelectionHeading').closest('.cc-accordion__item');
            var $coffeeSelectionBody = $('#coffeeSelectionCollapse .cc-accordion__body');

            if (hasCoffeeRange && $coffeeSelectionBody.length) {
                var coffeeAttrs = product.custom.coffeeAttributes;

                // Use pre-rendered content asset HTML if available
                if (coffeeAttrs.hasCoffeeRangeAsset && coffeeAttrs.coffeeRangeHtml) {
                    $coffeeSelectionBody.html(coffeeAttrs.coffeeRangeHtml);
                    $coffeeSelectionAccordion.show();
                } else if (coffeeAttrs.coffeeRangeDescription || coffeeAttrs.coffeeRange.label) {
                    // Build HTML from description
                    var coffeeSelectionHtml =
                        '<div class="cc-pdp__coffeeSelection">' +
                        '<div class="cc-pdp__coffeeSelection__info">' +
                        '<h3 class="cc-heading-sm d-flex cc-gap-sm">' +
                        coffeeAttrs.coffeeRange.label +
                        ' <span class="cc-accordion__icon"></span>' +
                        '</h3>' +
                        (coffeeAttrs.coffeeRangeDescription || '') +
                        '</div>' +
                        '<div class="cc-pdp__coffeeSelection__image">' +
                        '<picture>' +
                        '<source srcset="" media="(min-width: 1024px)" width="100%" height="auto" />' +
                        '<img src="" class="cc-pdp__differenceSection__card__image" alt="" />' +
                        '</picture>' +
                        '</div>' +
                        '</div>';

                    $coffeeSelectionBody.html(coffeeSelectionHtml);
                    $coffeeSelectionAccordion.show();
                } else {
                    $coffeeSelectionAccordion.hide();
                }
            } else {
                $coffeeSelectionAccordion.hide();
            }
        });
    },

    /**
     * Update expert opinion section with videos, scores, and criteria
     */
    updateExpertOpinion: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if (!response?.data?.product) return;

            var product = response.data.product;
            var expertAttrs = product.custom?.physicalProductAttributes;

            var hasExpertAuthor = expertAttrs?.maxiCoffeeExpert;
            var hasExpertImage = hasExpertAuthor && expertAttrs.maxiCoffeeExpert.img;
            var hasExpertQuote = expertAttrs?.expertSOpinion;
            var hasInfoSection = hasExpertImage || hasExpertQuote;

            var hasExpertVideo = expertAttrs?.expertVideo;
            var hasTutorialVideo = expertAttrs?.tutorialVideo;
            var hasSupplierVideo = expertAttrs?.supplierVideo;
            var hasAnyVideo = hasExpertVideo || hasTutorialVideo || hasSupplierVideo;

            var scoreParts = expertAttrs?.expertScoring?.split('_') || [];
            var hasExpertScoring = scoreParts.length > 1 && scoreParts[1] > 0;
            var hasExpertCriteria = expertAttrs?.expertCriteria?.length > 0;
            var hasReviewSection = hasExpertScoring || hasExpertCriteria;

            var hasMachineRange = expertAttrs?.coffeeMachineRange?.length > 0;
            var hasExpertOpinion = hasInfoSection || hasAnyVideo || hasReviewSection || hasMachineRange;

            var $expertOpinionAccordion = $('#descriptionAccordion #expertOpinionHeading').closest('.cc-accordion__item');
            var $expertOpinionBody = $('#expertOpinionCollapse .cc-accordion__body');

            if (hasExpertOpinion && $expertOpinionBody.length) {
                var expertOpinionHtml = '';

                // Info and Video Section
                if (hasInfoSection || hasAnyVideo) {
                    expertOpinionHtml += '<div class="cc-pdp__expertOpinion">';

                    if (hasInfoSection) {
                        expertOpinionHtml += '<div class="cc-pdp__expertOpinion__info">';
                        if (hasExpertImage) {
                            expertOpinionHtml +=
                                '<picture>' +
                                '<img src="' + expertAttrs.maxiCoffeeExpert.img + '" alt="' + (expertAttrs.maxiCoffeeExpert.alt || '') + '" />' +
                                '</picture>';
                        }
                        if (hasExpertQuote) {
                            expertOpinionHtml += '<blockquote class="cc-pdp__expertOpinion__quote">' + expertAttrs.expertSOpinion + '</blockquote>';
                        }
                        expertOpinionHtml += '</div>';
                    }

                    // Video Section
                    if (hasAnyVideo) {
                        var videoLanguage = (document.documentElement.lang || '').split(/[-_]/)[0].toLowerCase();
                        var videoPlayerTitle = $('#carouselAccessibilityLabels').attr('data-video-player-label') || '';
                        var primaryVideo = hasExpertVideo ? expertAttrs.expertVideo
                            : (hasTutorialVideo ? expertAttrs.tutorialVideo : expertAttrs.supplierVideo);

                        expertOpinionHtml +=
                            '<div class="cc-pdp__expertOpinion__video">' +
                            '<div class="cc-pdp__expertOpinion__mainVideo">' +
                        '<iframe class="js-mainExpertVideo" src="https://www.youtube.com/embed/' + primaryVideo + '?hl=' + encodeURIComponent(videoLanguage) + '" title="' + videoPlayerTitle + '" frameborder="0" allowfullscreen allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe>' +
                            '</div>' +
                            '<div class="cc-pdp__expertOpinion__videoThumbnails">';

                        // Add video thumbnails
                        [{ condition: hasExpertVideo, url: expertAttrs.expertVideo },
                        { condition: hasTutorialVideo, url: expertAttrs.tutorialVideo },
                        { condition: hasSupplierVideo, url: expertAttrs.supplierVideo }].forEach(function (video) {
                            if (video.condition) {
                                var activeClass = primaryVideo === video.url ? 'cc-pdp__expertOpinion__activeVideo ' : '';
                                expertOpinionHtml +=
                                    '<div class="cc-pdp__expertOpinion__videoThumbnail ' + activeClass + 'js-videoThumbnail" data-video-url="https://www.youtube.com/embed/' + video.url + '?hl=' + encodeURIComponent(videoLanguage) + '">' +
                                    '<img src="https://img.youtube.com/vi/' + video.url + '/hqdefault.jpg" alt="" />' +
                                    '</div>';
                            }
                        });

                        expertOpinionHtml += '</div></div>';
                    }

                    expertOpinionHtml += '</div>'; // End cc-pdp__expertOpinion
                }

                // Review Section (Scoring and Criteria)
                if (hasReviewSection) {
                    var resources = response.data?.resources || {};
                    expertOpinionHtml += '<div class="cc-pdp__expertOpinion__review">';

                    if (hasExpertScoring) {
                        var vote = scoreParts[0];
                        var total = scoreParts[1];
                        var scorePercentage = (vote / total) * 360;

                        expertOpinionHtml +=
                            '<div class="cc-pdp__expertOpinion__review__score">' +
                            '<h3 class="cc-heading-sm text-center">' + (resources.expertOpinionScoreLabel || 'Expert Score') + '</h3>' +
                            '<div class="cc-pdp__expertOpinion__scoreCircle">' +
                            '<div class="cc-pdp__expertOpinion__scoreProgress" style="--progress-angle: ' + scorePercentage + 'deg">' +
                            '<div class="cc-pdp__expertOpinion__scoreProgressInner">' +
                            '<div class="cc-pdp__expertOpinion__scoreValue">' + vote + '</div>' +
                            '<div class="cc-pdp__expertOpinion__scoreMax cc-text-md">' +
                            (resources.expertOpinionMaxScoreLabel ? resources.expertOpinionMaxScoreLabel.replace('{0}', total) : '/' + total) +
                            '</div>' +
                            '</div>' +
                            '</div>' +
                            '</div>' +
                            '</div>';
                    }

                    // Expert Criteria
                    if (hasExpertCriteria) {
                        expertOpinionHtml += '<div class="cc-pdp__expertOpinion__review__criteria">';
                        expertAttrs.expertCriteria.forEach(function (criterion) {
                            expertOpinionHtml += '<div class="cc-pdp__expertOpinion__review__criterion">' +
                                '<span class="cc-text-md">' + criterion.title + '</span>' +
                                '<div class="cc-pdp__expertOpinion__progressBar__wrapper">' +
                                '<div class="cc-pdp__expertOpinion__progressBar">';

                            // Progress bar segments
                            for (var i = 1; i <= 5; i++) {
                                var segmentFill = Math.min(Math.max(criterion.value - i + 1, 0), 1);
                                var style = segmentFill > 0 ? ' style="--fill-percentage: ' + (segmentFill * 100) + '%"' : '';
                                expertOpinionHtml += '<div class="cc-pdp__expertOpinion__progressBar__segment"' + style + '></div>';
                            }

                            var displayValue = criterion.value % 1 === 0 ? criterion.value.toFixed(0) : criterion.value.toFixed(1);
                            expertOpinionHtml +=
                                '</div>' +
                                '<span class="cc-pdp__expertOpinion__progressBar__value cc-text-md font-weight-bold">' + displayValue + '</span>' +
                                '</div>' +
                                '</div>';
                        });
                        expertOpinionHtml += '</div>';
                    }

                    expertOpinionHtml += '</div>'; // End review
                }

                // Machine Range Section
                if (hasMachineRange) {
                    var resources = response.data?.resources || {};
                    expertOpinionHtml +=
                        '<div class="cc-pdp__expertOpinion__machineRange">' +
                        '<h3 class="cc-heading-sm">' + (resources.expertOpinionMachineRangeLabel || 'Compatible Machine Range') + '</h3>' +
                        '<ul class="cc-pdp__expertOpinion__machineRange__list">';

                    expertAttrs.coffeeMachineRange.forEach(function (machineCategory) {
                        var selectedClass = machineCategory.isSelected ? 'cc-pdp__expertOpinion__machineRange__item__selected' : '';
                        expertOpinionHtml +=
                            '<li class="cc-pdp__expertOpinion__machineRange__item ' + selectedClass + '">' +
                            '<p class="cc-pdp__expertOpinion__machineRange__item__label cc-text-md font-weight-bold">' +
                            machineCategory.label +
                            (machineCategory.isSelected ? '<span class="sr-only">' + resources.expertOpinionMachineRangeSelectedLabel + '</span>' : '') +
                            '</p>' +
                            '</li>';
                    });

                    expertOpinionHtml += '</ul></div>';
                }

                $expertOpinionBody.html(expertOpinionHtml);
                $expertOpinionAccordion.show();
            } else {
                $expertOpinionAccordion.hide();
            }
        });
    },

    /**
     * Update freshness information for coffee products
     */
    updateFreshness: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if (!response?.data?.product) return;

            var product = response.data.product;
            var hasFreshness = product.custom?.coffeeAttributes?.maxicoffeeRoasting;

            var $freshnessAccordion = $('#descriptionAccordion #freshnessHeading').closest('.cc-accordion__item');
            var $freshnessBody = $('#freshnessCollapse .cc-accordion__body');

            if (hasFreshness && $freshnessBody.length) {
                var coffeeAttrs = product.custom.coffeeAttributes;

                if (coffeeAttrs.freshnessHtml) {
                    $freshnessBody.html(coffeeAttrs.freshnessHtml);
                    $freshnessAccordion.show();
                } else {
                    $freshnessAccordion.hide();
                }
            } else {
                $freshnessAccordion.hide();
            }
        });
    },

    /**
     * Update editorial section with product arguments and images
     */
    updateEditorialSection: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if (!response?.data?.product) return;

            var product = response.data.product;
            var hasEditorialSection = product.custom?.argumentImages?.length > 0;

            var $editorialSectionAccordion = $('#descriptionAccordion #editorialSectionHeading').closest('.cc-accordion__item');
            var $editorialSectionBody = $('#editorialSectionCollapse .cc-accordion__body');

            if (hasEditorialSection && $editorialSectionBody.length) {
                var editorialHtml = '<div class="cc-pdp__editorialSection">';

                product.custom.argumentImages.forEach(function (item) {
                    editorialHtml += '<div class="cc-pdp__editorialSection__item">';

                    if (item.img) {
                        editorialHtml +=
                            '<picture>' +
                            '<img class="cc-pdp__editorialSection__itemImage" src="' + item.img + '" alt="" />' +
                            '</picture>';
                    }

                    if (item.title || item.paragraph) {
                        editorialHtml += '<div class="cc-pdp__editorialSection__item__info">';
                        if (item.title) {
                            editorialHtml += '<h3 class="cc-heading-sm">' + item.title + '</h3>';
                        }
                        if (item.paragraph) {
                            editorialHtml += '<p class="cc-text-lg">' + item.paragraph + '</p>';
                        }
                        editorialHtml += '</div>';
                    }

                    editorialHtml += '</div>';
                });

                editorialHtml += '</div>';

                $editorialSectionBody.html(editorialHtml);
                $editorialSectionAccordion.show();
            } else {
                $editorialSectionAccordion.hide();
            }
        });
    },

    /**
     * Update identity card section with product characteristics
     */
    updateIdentityCard: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if (!response?.data?.product) return;

            var product = response.data.product;
            var hasIdentityCard = product.custom?.identityCards?.length > 0;

            var $identityCardAccordion = $('#descriptionAccordion #identityCardHeading').closest('.cc-accordion__item');
            var $identityCardBody = $('#identityCardCollapse .cc-accordion__body');

            if (hasIdentityCard && $identityCardBody.length) {
                var identityCardHtml = '<div class="cc-pdp__description__list">';

                product.custom.identityCards.forEach(function (element) {
                    var label = element.label || element.id;

                    identityCardHtml +=
                        '<div class="cc-pdp__description__list__item">' +
                        (element.icon ? '<picture><img class="cc-pdp__description__list__item__icon" src="' + element.icon + '" alt="" /></picture>' : '') +
                        '<div class="cc-pdp__description__list__item__text">' +
                    '<p class="cc-text-md text-center">' + label + '</p>' +
                        '<p class="cc-text-lg font-weight-bold text-center">' + element.value + '</p>' +
                        '</div>' +
                        '</div>';
                });

                identityCardHtml += '</div>';

                $identityCardBody.html(identityCardHtml);
                $identityCardAccordion.show();
            } else {
                $identityCardAccordion.hide();
            }
        });
    },

    /**
     * Update brand information section
     */
    updateBrandInfo: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if (!response?.data?.product) return;

            var product = response.data.product;
            var hasBrandInfo = product.custom?.brandInfo?.name;

            var $brandInfoAccordion = $('#descriptionAccordion #brandInfoHeading').closest('.cc-accordion__item');
            var $brandInfoBody = $('#brandInfoCollapse .cc-accordion__body');

            if (hasBrandInfo && $brandInfoBody.length) {
                var brandInfo = product.custom.brandInfo;
                var resources = response.data?.resources || {};

                var brandUrl = response.data.product.brandUrl ||
                    (window.Urls?.searchShow ? window.Urls.searchShow + '?cgid=' + encodeURIComponent(brandInfo.name) : '/search?cgid=' + encodeURIComponent(brandInfo.name));

                var brandInfoHtml =
                    '<div class="cc-pdp__brandInfo">' +
                    (brandInfo.logo ? '<picture><img class="cc-rounded-lg" src="' + brandInfo.logo + '" alt="' + brandInfo.name + '" /></picture>' : '') +
                    '<div class="cc-pdp__brandInfo__description">' +
                    (brandInfo.description ? '<p class="cc-text-lg">' + brandInfo.description + '</p>' : '') +
                    '<a href="' + brandUrl + '" class="cc-link cc-link--md cc-color-tertiary-darker">' + brandInfo.name + '</a>' +
                    '</div>' +
                    '</div>';

                $brandInfoBody.html(brandInfoHtml);

                // Update accordion title with brand name
                var titleResource = resources.brandInfoTitle;
                if (titleResource && brandInfo.name) {
                    var $accordionBtn = $brandInfoAccordion.find('.cc-accordion__btn');
                    var titleText = titleResource.replace('{0}', brandInfo.name);
                    $accordionBtn.find('span:not(.cc-accordion__icon)').remove();
                    $accordionBtn.append('<span>' + titleText + '</span>');
                }

                $brandInfoAccordion.show();
            } else {
                $brandInfoAccordion.hide();
            }
        });
    },

    /**
     * Update product characteristics section with technical specs
     */
    updateCharacteristics: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if (!response?.data?.product) return;

            var product = response.data.product;
            var hasCharacteristics = product.custom?.characteristics?.length > 0;

            var $characteristicsAccordion = $('#characteristicsAccordion .cc-accordion__item');
            var $characteristicsBody = $('#characteristicsCollapse .cc-accordion__body');

            if (hasCharacteristics && $characteristicsBody.length) {
                var resources = response.data?.resources || {};
                var characteristicsHtml = '';

                // Download notice link
                if (product.custom.noticelink) {
                    characteristicsHtml +=
                        '<a href="' + product.custom.noticelink + '" download class="cc-btn cc-btn--secondary cc-pdp__characteristics__downloadBtn">' +
                    '<span>' + (resources.downloadNoticeLabel) + '</span>' +
                        '</a>';
                }

                // Build characteristics table
                characteristicsHtml += '<div class="cc-pdp__characteristics__tableWrapper"><dl class="cc-pdp__characteristics__table">';

                product.custom.characteristics.forEach(function (characteristic) {
                    var keyLabel = characteristic.label || characteristic.id;
                    var valueDisplay = characteristic.value && characteristic.uom
                        ? characteristic.value + ' ' + characteristic.uom
                        : characteristic.value;

                    characteristicsHtml +=
                        '<div class="cc-pdp__characteristics__table__row">' +
                    '<dt class="cc-text-lg font-weight-bold">' + keyLabel + '</dt>' +
                    '<dd class="cc-text-lg">' + valueDisplay + '</dd>' +
                        '</div>';
                });

                characteristicsHtml += '</dl></div>';

                // Add compatible products if available
                if (product.custom.compatibleIDs?.length) {
                    var compatibleUrl = product.compatibleUrl || '#';

                    characteristicsHtml +=
                        '<div class="cc-pdp__characteristics__compatible">' +
                        '<div class="cc-pdp__characteristics__compatible__header">' +
                        '<h3 class="cc-heading-md">' + (resources.compatibleLabel || 'Compatible with') + '</h3>' +
                        (product.custom.compatibleIDs.length > 5 ? '<a href="' + compatibleUrl + '" class="cc-link cc-color-text-lighter">' + (resources.viewAllLabel || 'View All') + '</a>' : '') +
                        '</div>' +
                        '<div class="cc-pdp__characteristics__compatible__list" id="compatibleCarousel-' + product.id + '" data-interval="0">' +
                        '<div class="cc-pdp__characteristics__compatible__slider">' +
                        '<!-- Compatible products would be loaded here -->' +
                        '</div>' +
                        '</div>' +
                        '</div>';
                }

                $characteristicsBody.html(characteristicsHtml);
                $characteristicsAccordion.show();
            } else {
                $characteristicsAccordion.hide();
            }
        });
    },

    /**
     * Update product comparison table with similar products
     */
    updateProductComparison: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if (!response?.data?.product) return;

            var product = response.data.product;
            var hasProductComparison = product.custom?.productComparison?.products?.length > 0;

            var $comparisonAccordion = $('#comparisonAccordion .cc-accordion__item');
            var $comparisonBody = $('#comparisonCollapse .cc-accordion__body');

            if (hasProductComparison && $comparisonBody.length) {
                var resources = response.data?.resources || {};
                var comparisonData = product.custom.productComparison;

                var comparisonHtml = '<div class="cc-pdp__productComparison__wrapper"><table class="cc-pdp__productComparison"><thead><tr><th></th>';

                // Build table headers with product images and info
                comparisonData.products.forEach(function (compProduct) {
                    var isCurrentProduct = compProduct.id === product.id;
                    var headerClass = compProduct.isExpertsChoice ? ' class="cc-pdp__productComparison__expertsChoice"' : '';

                    comparisonHtml += '<th' + headerClass + '>' +
                        '<div class="cc-pdp__productComparison__header">' +
                        '<picture><img src="' + compProduct.image + '" alt="' + compProduct.name + '" /></picture>';

                    if (isCurrentProduct) {
                        comparisonHtml += '<span class="cc-pdp__productComparison__badge cc-pdp__productComparison__currentProduct">' +
                            (resources.currentProductLabel || 'Current Product') + '</span>';
                    } else if (compProduct.isExpertsChoice) {
                        comparisonHtml += '<span class="cc-pdp__productComparison__badge cc-pdp__productComparison__expertsChoiceBadge">' +
                            (resources.expertsChoiceLabel || "Experts' Choice") + '</span>';
                    }

                    comparisonHtml += '<p class="font-weight-bold">' + compProduct.name + '</p>' +
                        '<p>' + compProduct.price + '</p>' +
                        '</div></th>';
                });

                comparisonHtml += '</tr></thead><tbody>';

                // Build table rows with attribute comparisons
                if (comparisonData.labels) {
                    comparisonData.labels.forEach(function (attr) {
                        comparisonHtml += '<tr><th scope="row">' + attr.displayName + '</th>';

                        comparisonData.products.forEach(function (compProduct) {
                            var cellClass = compProduct.isExpertsChoice ? ' class="cc-pdp__productComparison__expertsChoice"' : '';
                            var attrValue = compProduct.attributes?.[attr.id] || '';
                            comparisonHtml += '<td' + cellClass + '>' + attrValue + '</td>';
                        });

                        comparisonHtml += '</tr>';
                    });
                }

                // Add to cart row
                var addToCartUrl = response.data.addToCartUrl || window.Urls?.addProduct || '/Cart-AddProduct';
                comparisonHtml += '<tr><th scope="row"></th>';

                comparisonData.products.forEach(function (compProduct) {
                    var isCurrentProduct = compProduct.id === product.id;
                    var cellClass = compProduct.isExpertsChoice ? ' class="cc-pdp__productComparison__expertsChoice"' : '';

                    comparisonHtml += '<td' + cellClass + '>';
                    if (!isCurrentProduct) {
                        comparisonHtml +=
                            '<div class="cc-pdp__product__addToCartButton__wrapper">' +
                            '<input type="hidden" class="comparison-add-to-cart-url" value="' + addToCartUrl + '" />' +
                            '<button type="button" class="cc-btn cc-btn--primary cc-pdp__product__addToCart js-addToCartComparison" data-pid="' + compProduct.id + '" data-quantity="1">' +
                            '<span>' + (resources.addToCartLabel || 'Add to Cart') + '</span>' +
                            '</button>' +
                            '</div>';
                    }
                    comparisonHtml += '</td>';
                });

                comparisonHtml += '</tr>';

                // View product row
                comparisonHtml += '<tr><th scope="row"></th>';

                comparisonData.products.forEach(function (compProduct) {
                    var isCurrentProduct = compProduct.id === product.id;
                    var cellClass = compProduct.isExpertsChoice ? ' class="cc-pdp__productComparison__expertsChoice"' : '';

                    comparisonHtml += '<td' + cellClass + '>';
                    if (!isCurrentProduct) {
                        var productUrl = compProduct.url || '/Product-Show?pid=' + compProduct.id;
                        comparisonHtml +=
                            '<a href="' + productUrl + '" class="cc-btn cc-btn--secondary w-100">' +
                            '<span>' + (resources.viewProductLabel || 'View Product') + '</span>' +
                            '</a>';
                    }
                    comparisonHtml += '</td>';
                });

                comparisonHtml += '</tr></tbody></table></div>';

                $comparisonBody.html(comparisonHtml);
                $comparisonAccordion.show();
            } else {
                $comparisonAccordion.hide();
            }
        });
    },
};